module.exports = __webpack_public_path__ + "static/assets/b99a2f3e2c5c39a223602c26be4f5154.png";